import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils, translate } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import classNames from 'classnames';
import MobileGlobalSearchDropdown from './dropdown';

const TIMEOUT_DELAY = 700;

class MobileGlobalSearch extends React.Component {
  constructor(props) {
    super(props);
    this.timer = 0;
    this.state = {
      showTextInput: false,
      keyword: null,
    };
  }

  componentDidMount() {
    Utils.OutsideClickHandler.registerNode(this.root, () => this._toggleSearch(false));
  }

  componentWillUnmount() {
    Utils.OutsideClickHandler.removeNode(this.root);
  }

  _onFilterChange = (keyword) => {
    this.setState({ keyword });
    if (this.timer) {
      clearTimeout(this.timer);
    }

    // Manually toggle isLoading to true when keyword changes and isloading is false.
    if (Utils.Helper.isNonEmptyString(keyword)) {
      if (!this.props.globalSearch.isLoading) {
        this.props.dispatch(ReduxActions.globalSearch.requestSearch());
      }

      this.timer = setTimeout(() => {
        this.props.dispatch(ReduxActions.globalSearch.search(keyword));
      }, TIMEOUT_DELAY);
    }
  }

  _onClickItem = (data) => {
    this._toggleSearch(false);
    this.props.onClickItem(data);
  }

  _toggleSearch(val) {
    if (Utils.Helper.isNullOrUndefined(val)) {
      this.setState(prevState => ({ showTextInput: !prevState.showTextInput }));
    } else {
      this.setState({ showTextInput: val });
    }

    if (!this.state.showTextInput) {
      this.setState({ keyword: null });
      if (this.props.globalSearch.tasks.length !== 0
        || this.props.globalSearch.jobs.length !== 0) {
        this.props.dispatch(ReduxActions.globalSearch.resetSearchResults());
      }
    }
  }

  _renderTextInput() {
    return (
      <Components.Input.Textbox
        onChange={this._onFilterChange}
        placeholder={this.props.strings.inputHint}
        value={this.state.keyword}
      />
    );
  }

  _renderDropdown() {
    if (Utils.Helper.isNonEmptyString(this.state.keyword)) {
      return (
        <MobileGlobalSearchDropdown
          isLoading={this.props.globalSearch.isLoading}
          jobs={this.props.globalSearch.jobs || []}
          onClickItem={this._onClickItem}
          tasks={this.props.globalSearch.tasks || []}
        />
      );
    }
    return false;
  }

  render() {
    const className = classNames('vf-mobile-global-search', this.props.className);

    return (
      <div className={className} ref={(c) => { this.root = c; }}>
        {this._renderTextInput()}
        {this._renderDropdown()}
      </div>
    );
  }
}

MobileGlobalSearch.displayName = 'Mobile Global Search';

MobileGlobalSearch.propTypes = {
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  globalSearch: PropTypes.shape({
    isLoading: PropTypes.bool,
    tasks: PropTypes.arrayOf(PropTypes.shape()),
    jobs: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  onClickItem: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    inputHint: PropTypes.string,
  }).isRequired,
};

MobileGlobalSearch.defaultProps = {
  className: null,
};

function mapStateToProps(state) {
  const { globalSearch } = state;
  return { globalSearch };
}

export default connect(mapStateToProps)(translate('MobileGlobalSearch')(MobileGlobalSearch));
